import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { LineItemFulfilmentCustomerHeaderView as LineItemFulfilmentCustomerHeaderViewUnified } from './LineItemFulfilmentCustomerHeaderView'
import { LineItemFulfilmentCustomerHeaderViewLegacy } from './LineItemFulfilmentCustomerHeaderViewLegacy'

export const LineItemFulfilmentCustomerHeaderView: React.FC = () => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentCustomerHeaderViewUnified />
  ) : (
    <LineItemFulfilmentCustomerHeaderViewLegacy />
  )
}
